import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ApplicationAccessService } from '../../services/application-access.service';
import { ApplicationTileComponent } from '../application-tile/application-tile.component';

@Component({
  selector: 'app-application-tiles',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ApplicationTileComponent
  ],
  templateUrl: './application-tiles.component.html'
})
export class ApplicationTilesComponent implements OnInit, OnDestroy {
  private appAccessService = inject(ApplicationAccessService);
  protected state$ = this.appAccessService.state$;
  private subscription?: Subscription;
  protected noRedirect = false;

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    this.noRedirect = urlParams.get('noredirect') === 'true';

    if (this.noRedirect) {
      return;
    }

    this.subscription = this.state$.pipe(
      filter(state => !state.loading && state.shouldRedirect && state.redirectTarget !== null),
      take(1)
    ).subscribe(state => {
      window.location.href = state.redirectTarget!.url;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
